import { render, staticRenderFns } from "./dayiHistory.vue?vue&type=template&id=04c050c4&scoped=true&"
import script from "./dayiHistory.vue?vue&type=script&lang=js&"
export * from "./dayiHistory.vue?vue&type=script&lang=js&"
import style0 from "./dayiHistory.vue?vue&type=style&index=0&id=04c050c4&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "04c050c4",
  null
  
)

export default component.exports